


































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {StripeElementCard} from "@vue-stripe/vue-stripe";

@Component({
    components: {
        StripeElementCard,
    }
})
export default class PaymentPortal extends Vue {

    @Prop({type: Number, default: 0})
    public defaultValue!: number;

    @Prop({type: Number})
    public maxValue!: number;

    @Prop({type: Boolean, default: false})
    public loading!: boolean;

    @Prop({type: String})
    public error!: string;

    private amount: number = 0;
    private stripeKey!: string;

    private loadingCard: boolean = false;

    private disabled: boolean = false;

    @Watch('loading')
    public loadingChange(loading: boolean) {
        this.disabled = loading ? true : this.loadingCard;
    }

    created() {
        // @ts-ignore
        this.stripeKey = process.env.VUE_APP_STRIPE_PUB_KEY;
        this.amount = this.defaultValue;
        this.loadingChange(this.loading);
    }

    submit() {
        this.$emit('clear');
        // @ts-ignore
        this.$refs.stripe.submit();
    }

    tokenCreated(cardObject: any) {
        this.$emit('token-change', cardObject.id);
        this.$emit('submit');
    }

    setError(error: any) {
        console.log(error);
    }

    setLoading(loading: boolean) {
        this.loadingCard = loading;
        this.disabled = this.loadingCard;
    }

    focus() {
        // @ts-ignore
        this.$refs.stripe.focus();
        // window.scrollTo(0,)
    }
}

